import React, { Component } from "react";
import imageHeros from "assets/frontend/images/img-01.png";

export default class HerosFrontend extends Component {
  render() {
    return (
      <section className="page-content content-heros">
        <div className="container mx-auto d-flex flex-column flex-lg-row heros">
          {/* <!-- left coloumn --> */}
          <div className="left-column d-flex flex-lg-grow-1 flex-column align-items-lg-start text-lg-start align-items-center text-center">
            <p className="text-caption">TamanDEV Indonesia</p>
            <h1 className="title-text-big mt-3">
              The Best way <br className="d-lg-block d-none" />
              to organize your online learning
            </h1>
            <div className="d-flex flex-sm-row flex-column align-items-center mx-lg-0 mx-auto justify-content-center gap-3">
              <button className="btn btn-get-started text-white mt-5">
                Get Started
              </button>
            </div>
          </div>
          {/* <!-- right column --> */}
          <div className="right-column text-center d-flex justify-content-center pe-0 mb-0">
            <img src={imageHeros} className="h-auto mw-100" alt="" />
          </div>
        </div>
      </section>
    );
  }
}
